<template>
    <el-input
        v-model="input"
        :placeholder="placeholder"
        class="input-with-select"
        :class="{ 'input-with-select--open': focused }"
        @blur="$emit('blur')"
    >
        <el-select :slot="selectPosition" v-model="select" @visible-change="focused = !focused">
            <el-option
                v-for="option in options"
                :key="option.value"
                :label="option.label"
                :value="option.value"
            >
            </el-option>
        </el-select>
    </el-input>
</template>
<script>
export default {
    props: {
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        value: {
            type: Object,
            required: true,
        },
        selectPosition: {
            type: String,
            default: 'append',
            required: false,
        },
    },
    data() {
        return {
            focused: false,
        };
    },
    computed: {
        input: {
            get() {
                return this.value.input;
            },
            set(input) {
                this.$emit('input', {
                    ...this.value,
                    input,
                });
            },
        },
        select: {
            get() {
                return this.value.select;
            },
            set(select) {
                this.$emit('input', {
                    ...this.value,
                    select,
                });
            },
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.input-with-select.el-input.el-input-group {
    .el-input-group__append .el-select {
        margin: 0;
    }
    .el-input__inner {
        height: auto;
    }
    .el-input-group__append {
        color: $gray-60;
        width: 100px;
    }
}
</style>
